import Model from '../Apis/GetFaqs.js'
import Controller from './Controller.js';

export default class GetFaqsController extends Controller {

    constructor() {
        super(new Model());
    }


}